import React, { useEffect, useState } from 'react';
import { Card, Collapse, List } from 'antd';
import { TableSecProps } from './props';

import { RowLine, SpanBlock } from './styles';
import { maskCurrency, maskUnd } from '../../../../../../utils/mask';
// import { OrdemCargaServices } from '../../services/ordemCargaServices';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../../../../../store';
import { Sorter, sorterParamsHandle } from '../../../../../../utils/sorte';

const CardSecMobile: React.FC<TableSecProps> = ({ ordemCarga, cddAtivo }) => {
  const { Panel } = Collapse;
  const [control, setControl] = useState(false);
  const { inscricaoAtiva } = useSelector((state: ApplicationState) => state.auth);
  const [loadingSec, setLoadingSec] = useState(false);
  const [response, setResponse] = useState();

  // useEffect(() => {
  //   let controller = new AbortController();
  //   if (control === false) {
  //     setLoadingSec(true);
  //     try {
  //       setLoadingSec(true);
  //       OrdemCargaServices.getPedidosOrdemCarga(
  //         ordemCarga,
  //         cddAtivo,
  //         inscricaoAtiva,
  //         sorterParamsHandle(Sorter)
  //       ).then((res) => {
  //         setResponse(res?.data.pedidos);
  //         if (res?.data.pedidos) setLoadingSec(false);
  //       });
  //     } finally {
  //       setControl(true);
  //     }
  //   }
  //   return () => {
  //     controller.abort();
  //   };
  // }, [cddAtivo, control, inscricaoAtiva, ordemCarga]);

  return (
    <Collapse key={ordemCarga}>
      <Panel header="Detalhes" key={ordemCarga}>
        <>
          <List
            dataSource={response}
            loading={loadingSec}
            renderItem={(item: any) => (
              <List.Item>
                <Card>
                  <RowLine>
                    <p>
                      <strong>N° da NF</strong> <SpanBlock>{item.numNota}</SpanBlock>
                    </p>
                  </RowLine>
                  <RowLine>
                    <p>
                      <strong>Fornecedor</strong> <SpanBlock>{item.fornecedor}</SpanBlock>
                    </p>
                  </RowLine>
                  <RowLine>
                    <p>
                      <strong>Cidade origem</strong> <SpanBlock>{item.cidadeOrigem}</SpanBlock>
                    </p>
                  </RowLine>
                  <RowLine>
                    <p>
                      <strong>Destinatário</strong> <SpanBlock>{item.destinatario}</SpanBlock>
                    </p>
                  </RowLine>
                  <RowLine>
                    <p>
                      <strong>Peso Bruto</strong>{' '}
                      <SpanBlock>{maskUnd(item.pesoBruto) + ' KG'}</SpanBlock>
                    </p>
                  </RowLine>
                  <RowLine>
                    <p>
                      <strong>Valor da mercadoria</strong>{' '}
                      <SpanBlock>{maskCurrency(item.valor)}</SpanBlock>
                    </p>
                  </RowLine>

                  <RowLine>
                    <p>
                      <strong>Quantidade</strong> <SpanBlock>{item.qtdVolume}</SpanBlock>
                    </p>
                  </RowLine>
                  <RowLine>
                    <p>
                      <strong>Tipo de volume</strong> <SpanBlock>{item.tipoVolume}</SpanBlock>
                    </p>
                  </RowLine>
                </Card>
              </List.Item>
            )}
          />
        </>
      </Panel>
    </Collapse>
  );
};

export default CardSecMobile;
